import FieldConfig from "../../../../proto/field-config";
import FieldDate from "../../../../generic/datetime/date/date";
import Task from "../../../../../model2/task/task";
import ItemModel from "../../../../../model2/item/item-model";
import {LifecycleAction} from "../../../../../gd/const/lifecycle";
import TableManager from "../../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../../gd-modules/task-list/manager/manager";


export default class FieldTaskDeadline extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.fieldParams.highlightIfPastdue = true

        this.icon               = 'i5-deadline'
        this.label              = 'Deadline'

        this.minDate            = moment()

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    // ACCESS
    canEdit(model:Task):boolean {
        return model.acl.canChangeDeadline
    }

    // Custom Methods

    tableCellOnValueChange = async (item:ItemModel, value:Moment|null, manager:TableManager|TaskListManager) => {

        item.task.deadline = value ? value : null
        item.task.save()

        item._updateLastUpdateTime() // otherwise it wont re-render

        // Aggregated values...
        manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

    }
}
